module.exports = __webpack_public_path__ + "img/239.a8a20d1b.png";